<!-- <div class="flex flex-col w-full !max-w-5xl 2xl:!max-w-8xl inset-x-0 mx-auto absolute justify-start top-52 lg:top-60 items-center flex-1 space-y-8 p-6 md:p-16">     -->
<div
  class="flex flex-col container inset-x-0 mx-auto relative top-0 justify-center items-center flex-1 space-y-8 min-h-screen px-6 pb-48 pt-44 md:px-16"
>
  <div class="grid grid-cols-12 justify-start items-center gap-4">
    <div
      class="col-span-12 lg:col-span-7 flex flex-col justify-between relative pb-6"
    >
      <img
        src="assets/landing-new/icons/star-lg.svg"
        class="absolute animate-blink top-0 left-0 w-16 h-16 star1"
        alt=""
      />
      <img
        src="assets/landing-new/icons/star-sm.svg"
        class="absolute animate-blink bottom-4 md:bottom-0 left-56 sm:left-72 md:left-80"
        alt=""
      />
      <div
        class="space-y-6 lg:space-y-8"
        data-aos="fade-up"
        data-aos-delay="100"
      >
        <h2
          class="text-3xl xl:text-5xl mi--font-regular text-white leading-snug lg:!leading-[1.16]"
        >
          A Complete <span class="text__yg--gradient">No-code</span> <br />
          Web3 Ecosystem
          <img
            src="assets/landing-new/icons/star-md.svg"
            class="animate-blink inline pl-2"
            alt=""
          />
        </h2>
        <div
          class="border-b border-solid border-[#d9d9d980] w-24 lg:w-80"
        ></div>
        <p
          class="text-base md:text-lg xl:text-2xl mi--font-regular text-white leading-normal lg:leading-5"
        >
          Build your project literally in Minutes
        </p>
      </div>
      <div
        class="flex items-center gap-4 mt-6 md:mt-12"
        data-aos="fade-up"
        data-aos-delay="400"
        data-aos-duration="1000"
      >
        <a
          href="https://docs.google.com/forms/d/16t83GnB8e3ZC3IZK-PmQkfjPgsO2btQu2eoPSTFi2E0/viewform?edit_requested=true"
          target="_blank"
          class="cursor-pointer text-sm md:text-lg sy--font-medium text-white border-solid border-[#D9D9D9] border-b py-1 lg:py-3 animate-slide"
        >
          Invest in Us
          <img
            class="inline ml-2"
            src="assets/landing-new/icons/arrow-right.svg"
            alt=""
        /></a>
      </div>
    </div>
    <div
      class="col-span-12 lg:col-span-5 relative"
      data-aos="fade-zoom-in"
      data-aos-offset="100"
      data-aos-easing="ease-in-sine"
      data-aos-duration="100"
    >
      <div class="relative pr-24">
        <img
          src="assets/landing-new/images/banner-right-img.svg"
          class="hidden lg:block animate-float lg:w-[400px] 2xl:w-[550px] mx-auto object-contain"
          alt=""
        />
        <div class="bg__radial--gradient hidden lg:block"></div>
      </div>

      <img
        src="assets/landing-new/icons/star-banner-img.svg"
        class="hidden lg:block absolute animate-blink top-20 right-0"
        alt=""
      />
    </div>
  </div>
</div>
